var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinRightBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.6963 24.213L71.7773 6.29199C74.9629 8.11255 77.9096 10.2858 80.5832 12.7549L83.2341 15.4061C85.7029 18.0687 87.876 21.0271 89.6963 24.213Z",
    fill: "#D5EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0439 38.4591L57.5336 0.944336C58.5689 1.14915 59.5928 1.39947 60.6054 1.67256L94.3158 35.3869C94.6002 36.3996 94.8392 37.4237 95.0439 38.4591Z",
    fill: "#D5EDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 47.9943C96 48.0967 96 48.1991 96 48.3015L47.7042 0C47.8066 0 47.909 0 48.0113 0C48.7053 0 49.3994 0.0227493 50.0934 0.0455062L95.9545 45.9121C95.9773 46.6061 96 47.2889 96 47.9943Z",
    fill: "#D5EDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2494 56.4481L39.5358 0.727775C40.207 0.613991 40.8896 0.500207 41.5608 0.40918L95.5566 54.4113C95.477 55.1054 95.3746 55.7767 95.2494 56.4481Z",
    fill: "#D5EDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4289 63.5259L32.4703 2.56013C33.0619 2.35532 33.6535 2.17327 34.2451 1.99121L93.9863 61.7395C93.8157 62.3425 93.6336 62.9342 93.4289 63.5259Z",
    fill: "#D5EDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7771 69.7726L26.212 5.19985C26.7354 4.93815 27.2588 4.67645 27.7935 4.4375L91.5508 68.191C91.3005 68.7258 91.0502 69.2492 90.7771 69.7726Z",
    fill: "#D5EDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4548 75.3372L20.6598 8.53426C21.1262 8.21566 21.5927 7.89706 22.0592 7.58984L88.3877 73.9262C88.0805 74.4041 87.7734 74.8707 87.4548 75.3372Z",
    fill: "#D5EDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5077 80.2862L15.7116 12.482C16.1211 12.1065 16.5421 11.7424 16.963 11.3896L84.6113 79.0459C84.2473 79.4669 83.8832 79.8765 83.5077 80.2862Z",
    fill: "#D5EDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.98 84.6553L11.343 17.0104C11.6957 16.5894 12.0598 16.1684 12.4353 15.7588L80.2314 83.563C79.8219 83.9385 79.4009 84.3026 78.98 84.6553Z",
    fill: "#D5EDFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8598 88.4329L7.55392 22.1193C7.8611 21.6414 8.1683 21.1749 8.49824 20.7197L75.2705 87.4998C74.804 87.8184 74.3376 88.137 73.8598 88.4329Z",
    fill: "#D5EDFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1149 91.5855L4.41442 27.8775C4.66472 27.3427 4.91507 26.8193 5.17674 26.2959L69.6963 90.8231C69.1729 91.0848 68.6496 91.3351 68.1149 91.5855Z",
    fill: "#D5EDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6528 94.0205L1.96856 34.3405C2.15059 33.7374 2.33261 33.1457 2.52602 32.5654L63.4277 93.4743C62.8475 93.6563 62.2558 93.8384 61.6528 94.0205Z",
    fill: "#D5EDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3255 95.5787L0.420731 41.6676C0.511745 40.9849 0.614094 40.3136 0.727863 39.6309L56.3506 95.2601C55.6793 95.3853 55.0081 95.4877 54.3255 95.5787Z",
    fill: "#D5EDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 96.0002C47.2607 96.0002 46.5213 95.9775 45.7931 95.9434L0.0571175 50.2019C0.0229874 49.4737 0.000247955 48.7342 0.000247955 47.9946C0.000247955 47.9377 0.000247955 47.8694 0.000247955 47.8125L48.1709 95.9889C48.1254 95.9889 48.0571 96.0002 48.0002 96.0002Z",
    fill: "#D5EDFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2237 94.2702L1.72953 60.772C1.44511 59.7593 1.19485 58.7239 0.990063 57.6885L38.3184 95.0212C37.2717 94.805 36.2363 94.5547 35.2237 94.2702Z",
    fill: "#D5EDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47326 72.0713L23.9258 89.5259C16.7013 85.3272 10.6714 79.2966 6.47326 72.0713Z",
    fill: "#D5EDFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6631 16.768L81.0959 13.3333L77.6631 9.8987C77.2311 9.46648 77.2311 8.75639 77.6631 8.32417C78.0951 7.89194 78.8048 7.89194 79.2368 8.32417L82.6696 11.7588L86.1023 8.32417C86.5343 7.89194 87.244 7.89194 87.676 8.32417C88.108 8.75639 88.108 9.46648 87.676 9.8987L84.2433 13.3333L87.676 16.768C88.108 17.2002 88.108 17.9103 87.676 18.3425C87.244 18.7747 86.5343 18.7747 86.1023 18.3425L82.6696 14.9079L79.2368 18.3425C78.8048 18.7747 78.0951 18.7747 77.6631 18.3425C77.2234 17.9103 77.2234 17.2079 77.6631 16.768Z",
    fill: "#9FD2F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinRightBig);
export default __webpack_public_path__ + "static/media/pin-right-big.38ff0d1338e61ddc684070cd38797f49.svg";
export { ForwardRef as ReactComponent };